<template>
  <footer
    id="common-footer"
    role="contentinfo"
  >
    <section id="common-footer__container">
      <p
        id="common-footer__copyright"
        class="copy"
      >
        © 2016-{{ new Date().getFullYear() }} Ifrågasätt Media Sverige AB
      </p>
      <span id="common-footer__version">v{{ version }}</span>
      <a
        id="common-footer__mail"
        class="copy"
        href="mailto:info@ifragasatt.se"
        target="_top"
      >info@ifragasatt.se</a>
    </section>
  </footer>
</template>

<script>
export default {
  name: "CommonFooter",
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    }
  }
};
</script>
